import { render, staticRenderFns } from "./labelNodeHeader.vue?vue&type=template&id=ae6a0536&scoped=true"
import script from "./labelNodeHeader.vue?vue&type=script&lang=js"
export * from "./labelNodeHeader.vue?vue&type=script&lang=js"
import style0 from "./labelNodeHeader.vue?vue&type=style&index=0&id=ae6a0536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6a0536",
  null
  
)

export default component.exports